type Icon = {
  color?: string;
  fillColor?: string;
  strokeColor?: string;
};

export const ArrowDropDown20 = ({ color }: Icon) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.61872 7.71331C5.27701 7.3716 4.72299 7.3716 4.38128 7.71331C4.03957 8.05502 4.03957 8.60904 4.38128 8.95075L5.61872 7.71331ZM10 13.332L9.38128 13.9507C9.72299 14.2925 10.277 14.2925 10.6187 13.9507L10 13.332ZM15.6187 8.95075C15.9604 8.60904 15.9604 8.05502 15.6187 7.71331C15.277 7.3716 14.723 7.3716 14.3813 7.71331L15.6187 8.95075ZM4.38128 8.95075L9.38128 13.9507L10.6187 12.7133L5.61872 7.71331L4.38128 8.95075ZM10.6187 13.9507L15.6187 8.95075L14.3813 7.71331L9.38128 12.7133L10.6187 13.9507Z"
        fill={color}
      />
    </svg>
  );
};

export const ArrowDropDown32 = ({ color }: Icon) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.70711 12.6239C8.31658 12.2334 7.68342 12.2334 7.29289 12.6239C6.90237 13.0145 6.90237 13.6476 7.29289 14.0382L8.70711 12.6239ZM16 21.3311L15.2929 22.0382C15.6834 22.4287 16.3166 22.4287 16.7071 22.0382L16 21.3311ZM24.7071 14.0382C25.0976 13.6476 25.0976 13.0145 24.7071 12.6239C24.3166 12.2334 23.6834 12.2334 23.2929 12.6239L24.7071 14.0382ZM7.29289 14.0382L15.2929 22.0382L16.7071 20.6239L8.70711 12.6239L7.29289 14.0382ZM16.7071 22.0382L24.7071 14.0382L23.2929 12.6239L15.2929 20.6239L16.7071 22.0382Z"
        fill="#9DA7AE"
      />
    </svg>
  );
};

export const CloseCircleFill20 = ({ fillColor, strokeColor }: Icon) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="10"
        cy="10"
        r="7.5"
        fill={fillColor}
        stroke={fillColor}
        strokeWidth="1.75"
      />
      <path
        d="M7.5 7.5L12.5 12.5"
        stroke={strokeColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 7.5L7.5 12.5"
        stroke={strokeColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CheckLine16 = ({ strokeColor }: Icon) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.66565 8L5.99898 11.3333L13.3323 4"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ClockLine24 = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 13C20 17.4183 16.4183 21 12 21C7.58172 21 4 17.4183 4 13C4 8.58172 7.58172 5 12 5C16.4183 5 20 8.58172 20 13Z"
        stroke="#141617"
        strokeWidth="2"
      />
      <path
        d="M12 9V13"
        stroke="#141617"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M19.5 5.5L18.1716 6.82843"
        stroke="#141617"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M9 2H15"
        stroke="#141617"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
